import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("clarity_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("clarity_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("clarity_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("clarity_token");
        localStorage.removeItem("clarity_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const persist = (token, u) => {
    localStorage.setItem("clarity_token", token);
    localStorage.setItem("clarity_user", JSON.stringify(u));
    setUser(u);
  };

  const login = async (email, password, code) => {
    const { data } = await api.post("/auth/login", { email, password, code });
    persist(data.token, data.user);
    return data.user;
  };

  const register = async (email, password, name, referral_code, accept_terms, confirm_adult) => {
    const { data } = await api.post("/auth/register", { email, password, name, referral_code: referral_code || null, accept_terms: !!accept_terms, confirm_adult: !!confirm_adult });
    persist(data.token, data.user);
    return data.user;
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("clarity_user", JSON.stringify(data));
      return data;
    } catch {
      return null;
    }
  };

  const logout = () => {
    localStorage.removeItem("clarity_token");
    localStorage.removeItem("clarity_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
